<template>
  <div
    class="bg-green-lightest md:flex h-screen shadow-xl z-20 fixed left-0 md:w-auto w-56 sidebarClosed"
    v-show="isMenuOpen || screenWidth > 768"
    v-bind:class="{ sidebarOpen: isMenuOpen }"
  >
    <ul>
      <li>
        <div
          class="absolute top-0 right-0 -mr-8 pt-4 pl-2 flex sm:-mr-10 sm:pl-4"
        >
          <button
            type="button"
            class="rounded-md text-gray-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-white sm:hidden block"
            @click.prevent="toggleMenuOpen"
          >
            <span class="sr-only">Close panel</span>
            <!-- Heroicon name: outline/x -->
            <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </li>
      <li class="md:px-8 md:py-5 px-4 py-4">
        <button
          class="hidden md:inline text-gray-light focus:outline-none"
          aria-label="Main menu"
          aria-expanded="false"
          @click="toggleMenuOpen"
        >
          <Tooltip
            trigger="hover"
            :options="{
              placement: 'right',
              modifiers: { offset: { offset: '0,2px' } },
            }"
          >
            <Menu slot="reference" />
            <transition name="slide-text">
              <span class="popper text-sm" v-show="!isMenuOpen"> Menu</span>
            </transition>
          </Tooltip>
        </button>
        <router-link :to="{ name: 'DashboardBeforeLogin' }" class="px-4 md:hidden">
          <img
            :src="require(`@/assets/img/fitclas.png`)"
            alt=""
            class="w-24 object-cover"
          />
        </router-link>
      </li>
      <li class="md:px-8 px-4 py-5">
        <router-link
          :to="{ name: 'DashboardBeforeLogin' }"
          class="text-gray-light hover:text-green-dark text-sm"
          exact-active-class="text-green-dark"
        >
          <div class="flex py-2">
            <Tooltip
              trigger="hover"
              :options="{
                placement: 'right',
                modifiers: { offset: { offset: '0,2px' } },
              }"
            >
              <Home slot="reference" />
              <transition name="slide-text">
                <span class="popper text-sm" v-show="!isMenuOpen"> Home</span>
              </transition>
            </Tooltip>
            <span class="ml-5 w-32" v-show="isMenuOpen">Home</span>
          </div>
        </router-link>
      </li>
      <li class="md:px-8 px-4 py-5">
        <router-link
          :to="{ name: 'UserSessions' }"
          class="text-gray-light hover:text-green-dark text-sm"
          exact-active-class="text-green-dark"
        >
          <div class="flex py-2">
            <Tooltip
              trigger="hover"
              :options="{
                placement: 'right',
                modifiers: { offset: { offset: '0,2px' } },
              }"
            >
              <DesktopComputer slot="reference" />
              <transition name="slide-text">
                <span class="popper text-sm" v-show="!isMenuOpen">
                  My Upcoming Classes</span
                >
              </transition>
            </Tooltip>
            <span class="ml-5 w-32" v-show="isMenuOpen">Upcoming Classes</span>
          </div>
        </router-link>
      </li>
      <li class="md:px-8 px-4 py-5">
        <router-link
          :to="{ name: 'SessionsFind' }"
          class="text-gray-light hover:text-green-dark text-sm"
          exact-active-class="text-green-dark"
        >
          <div class="flex py-2">
            <Tooltip
              trigger="hover"
              :options="{
                placement: 'right',
                modifiers: { offset: { offset: '0,2px' } },
              }"
            >
              <Briefcase slot="reference" />
              <transition name="slide-text">
                <span class="popper" v-show="!isMenuOpen">Find Classes</span>
              </transition>
            </Tooltip>
            <span class="ml-5 w-32" v-show="isMenuOpen">Find Classes</span>
          </div>
        </router-link>
      </li>
      <li class="md:px-8 px-4 py-5">
        <router-link
          :to="{ name: 'TrainersFind' }"
          class="text-gray-light hover:text-green-dark text-sm"
          exact-active-class="text-green-dark"
        >
          <div class="flex py-2">
            <Tooltip
              trigger="hover"
              :options="{
                placement: 'right',
                modifiers: { offset: { offset: '0,2px' } },
              }"
            >
              <ChartBar slot="reference" />
              <transition name="slide-text">
                <span class="popper" v-show="!isMenuOpen">Find Trainers</span>
              </transition>
            </Tooltip>
            <span class="ml-5 w-32" v-show="isMenuOpen">Find Trainers</span>
          </div>
        </router-link>
      </li>
      <!-- <li class="md:px-8 px-4 py-5">
        <router-link
          :to="{ name: 'VodList' }"
          class="text-gray-light hover:text-green-dark text-sm"
          exact-active-class="text-green-dark"
        >
          <div class="flex py-2 tooltip">
            <div>
              <DesktopComputer class="absolute" />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                viewBox="-1 -1 25 25"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-video pl-2"
              >
                <polygon points="23 7 16 12 23 17 23 7"></polygon>
                <rect x="" y="5" width="15" height="14" rx="2" ry="2"></rect>
              </svg>
            </div>
            <transition name="slide-text">
              <span class="ml-5 w-32" v-show="isMenuOpen">
                On Demand Classes
              </span>
            </transition>
            <span class="tooltiptext" v-show="!isMenuOpen">
              On Demand Classes
            </span>
          </div>
        </router-link>
      </li> -->
    </ul>
  </div>
</template>

<script>
import {
  Menu,
  Home,
  DesktopComputer,
  Briefcase,
  ChartBar,
} from "@/components/icons";
import Tooltip from "@/components/Tooltip.vue";

export default {
  name: "UserSidebar",
  components: {
    Menu,
    Home,
    DesktopComputer,
    Briefcase,
    ChartBar,
    Tooltip,
  },
  props: {
    isMenuOpen: {
      type: Boolean,
    },
  },
  data() {
    return {
      screenWidth: screen.width,
    };
  },
  methods: {
    toggleMenuOpen() {
      this.isMenuOpen = !this.isMenuOpen;
      this.$emit("is-menu-open", this.isMenuOpen);
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.screenWidth = window.innerWidth;
    });
  },
};
</script>

<style scoped>
.sidebarClosed {
  transition: max-height 0.25s ease-out;
  width: 88px;
  transition-property: width;
}
.sidebarOpen {
  transition: max-height 0.25s ease-out;
  width: 207px;
  transition-property: width;
}
</style>
